export enum AdsTabs {
  Campaigns = "Campaigns",
  Keywords  = "Keywords"
}
